<template>
  <div id="app">
    <v-app id="inspire" v-if="$store.getters['Authorization/isLoggedIn']">
      <v-navigation-drawer
        app
        fixed
        v-model="menu"
      >
        <img :src="require('../assets/logo.png')" @click="$router.push({name: 'home'})" class="logo">
        <v-divider class="mt-10"/>
        <main-menu/>
      </v-navigation-drawer>
      <v-app-bar app color="primary" dark mfixed>
        <v-app-bar-nav-icon @click.stop="menu = !menu"></v-app-bar-nav-icon>
        <v-toolbar-title>Beheer</v-toolbar-title>
        <v-spacer/>
        <profile-menu></profile-menu>
      </v-app-bar>
      <v-main>
        <router-view/>
      </v-main>
      <v-footer app color="primary" inset>
        <span class="white--text">Created by Kings Code</span>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import MainMenu from './../components/MainMenu.vue';
import ProfileMenu from './../components/ProfileMenu.vue';

export default {
  name: 'template-default',
  components: {ProfileMenu, MainMenu},
  data() {
    return {
      menu: true,
    };
  },
  beforeCreate() {
    if (!this.$store.getters['Authorization/isLoggedIn']) {
      this.$router.push({name: 'login'});
    }
  },
};
</script>

<style scoped lang="scss">

.logo {
  display: block;
  margin:  30px auto;
  width:   50%;
  cursor:  pointer;
}
</style>
<style lang="scss">
.v-dialog--fullscreen > .v-card.v-sheet.theme--light {
  background: rgb(248, 249, 250);
}
</style>
